module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_c('div', {
    staticClass: "box box-primary center-block relatorio-estatistico"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-dashboard font-dark"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Relatório Estatístico Nacional")])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row filter-row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    staticClass: "filter-label"
  }, [_vm._v("\n            Ano de referência\n            "), _c('span', {
    staticClass: "filter-hint",
    attrs: {
      "tabindex": "0"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "filter-hint__bubble"
  }, [_vm._v(_vm._s(_vm.yearHint))])])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.year),
      expression: "year",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.isBusy
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.year = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.availableYears), function(y) {
    return _c('option', {
      key: y,
      domProps: {
        "value": y
      }
    }, [_vm._v(_vm._s(y))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    staticClass: "filter-label"
  }, [_vm._v("\n            Ano comparativo\n            "), _c('span', {
    staticClass: "filter-hint",
    attrs: {
      "tabindex": "0"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "filter-hint__bubble"
  }, [_vm._v(_vm._s(_vm.compareYearHint))])])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.compareYear),
      expression: "compareYear"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.isBusy
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.compareYear = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Nenhum")]), _vm._v(" "), _vm._l((_vm.compareYearOptions), function(y) {
    return _c('option', {
      key: 'c-' + y,
      domProps: {
        "value": y
      }
    }, [_vm._v(_vm._s(y))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 filter-actions"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.isBusy
    },
    on: {
      "click": _vm.loadRelatorio
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    class: {
      'fa-spin': _vm.loading
    }
  }), _vm._v("\n            Gerar relatório\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isBusy || !_vm.relatorio
    },
    on: {
      "click": _vm.downloadExcel
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    class: {
      'fa-spin': _vm.downloading === 'excel'
    }
  }), _vm._v("\n            Excel\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": _vm.isBusy || !_vm.relatorio
    },
    on: {
      "click": _vm.downloadPdf
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o",
    class: {
      'fa-spin': _vm.downloading === 'pdf'
    }
  }), _vm._v("\n            PDF\n          ")])])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("\n        Gerando relatório estatístico… isso pode levar vários minutos.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.downloading) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("\n        " + _vm._s(_vm.exportStatusMessage) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.infoMessage) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v(_vm._s(_vm.infoMessage))]) : _vm._e(), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), _vm._v(" "), (_vm.relatorio) ? _c('div', {
    staticClass: "relatorio-summary"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "info-box bg-aqua"
  }, [_c('span', {
    staticClass: "info-box-icon"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Ano")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v(_vm._s(_vm.relatorio.year))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "info-box bg-green"
  }, [_c('span', {
    staticClass: "info-box-icon"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Indicadores")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v(_vm._s(_vm.relatorio.indicators.length))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "info-box bg-yellow"
  }, [_c('span', {
    staticClass: "info-box-icon"
  }, [_c('i', {
    staticClass: "fa fa-folder-open"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Seções")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v(_vm._s(_vm.relatorio.sections.length))])])])]), _vm._v(" "), (_vm.summaryKpis.totalParques !== null) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "info-box bg-red"
  }, [_c('span', {
    staticClass: "info-box-icon"
  }, [_c('i', {
    staticClass: "fa fa-tree"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Parques em operação")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v(_vm._s(_vm.summaryKpis.totalParques))])])])]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "text-muted generated-at"
  }, [_vm._v("\n          Gerado em " + _vm._s(_vm.formatGeneratedAt(_vm.relatorio.generatedAt)) + "\n          "), (_vm.relatorio.compareYear) ? _c('span', [_vm._v(" · Comparativo com " + _vm._s(_vm.relatorio.compareYear))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.relatorio) ? _c('div', {
    staticClass: "section-nav"
  }, _vm._l((_vm.relatorio.sections), function(section) {
    return _c('button', {
      key: section.id,
      staticClass: "btn btn-default btn-sm section-nav-btn",
      class: {
        active: _vm.activeSectionId === section.id
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.scrollToSection(section.id)
        }
      }
    }, [_vm._v("\n          " + _vm._s(section.label) + "\n        ")])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.relatorio) ? _c('div', _vm._l((_vm.relatorio.sections), function(section) {
    return _c('div', {
      key: section.id,
      staticClass: "report-section panel panel-default",
      attrs: {
        "id": 'section-' + section.id
      }
    }, [_c('div', {
      staticClass: "panel-heading",
      on: {
        "click": function($event) {
          return _vm.toggleSection(section.id)
        }
      }
    }, [_c('h3', {
      staticClass: "panel-title"
    }, [_c('i', {
      staticClass: "fa",
      class: _vm.isSectionExpanded(section.id) ? 'fa-chevron-down' : 'fa-chevron-right'
    }), _vm._v("\n              " + _vm._s(section.label) + "\n              "), _c('span', {
      staticClass: "badge"
    }, [_vm._v(_vm._s(section.indicators.length))])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isSectionExpanded(section.id)),
        expression: "isSectionExpanded(section.id)"
      }],
      staticClass: "panel-body"
    }, _vm._l((section.indicators), function(indicator) {
      return _c('IndicatorResult', {
        key: indicator.id,
        attrs: {
          "indicator": indicator,
          "chart-visible": _vm.isSectionExpanded(section.id)
        }
      })
    }), 1)])
  }), 0) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-82b1981e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/reports/RelatorioEstatistico.vue
// module id = 753
// module chunks = 1